(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["0x-dual-video-promo"] && !Shopify.designMode) return;
  try {
    
  class DualVideoPromo extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedAndReady) return;

      this.isConnectedAndReady = true;
      this.isDisconnecting = false;
      this.abortController = new AbortController();
      this.frame = this.querySelector('.dvp__frame');
      this.firstVideos = Array.from(this.querySelectorAll('.dvp__video--first'));
      this.secondVideos = Array.from(this.querySelectorAll('.dvp__video--second'));
      this.videos = [...this.firstVideos, ...this.secondVideos];
      this.playFallback = this.querySelector('.dvp__play-fallback');
      this.videoControls = this.querySelector('[data-video-controls]');
      this.replayButton = this.querySelector('[data-video-replay]');
      this.contentLayer = this.querySelector('[data-content-layer]');
      this.contentPositioners = Array.from(this.querySelectorAll('[data-content-positioner]'));
      this.overlayContents = this.querySelectorAll('[data-overlay-content]');
      this.mobileBreakpoint = Math.max(1, Number.parseInt(this.dataset.mobileBreakpoint, 10) || 750);
      this.isUsingMobileVideoSet = this.isMobileViewport();
      this.activateVideoSet();
      this.overlayDelayMilliseconds = Math.max(0, (Number.parseFloat(this.dataset.overlayDelay) || 0) * 1000);
      const configuredTransitionDuration = Number.parseInt(this.dataset.videoTransitionDuration, 10);
      this.videoTransitionDurationMilliseconds = Number.isFinite(configuredTransitionDuration)
        ? Math.max(0, configuredTransitionDuration)
        : 600;
      this.overlayRemainingMilliseconds = this.overlayDelayMilliseconds;
      this.overlayCountdownStartedAt = null;
      this.replayRevealDelayMilliseconds = 2000;
      this.replayRevealRemainingMilliseconds = this.replayRevealDelayMilliseconds;
      this.replayRevealCountdownStartedAt = null;
      this.replayRevealTimer = null;
      this.hasSwitched = false;
      this.hasShownOverlay = false;
      this.isTransitioning = false;
      this.isPreparingSecond = false;
      this.isCrossfading = false;
      this.autoplayBlocked = false;
      this.playRequestId = 0;
      this.resumeFrame = null;
      this.contentLayoutFrame = null;
      this.crossfadeFrame = null;
      this.crossfadeTimer = null;
      this.resetTransitionFrame = null;
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.reducedMotionQuery.matches;
      this.shouldShowOverlayInEditor = Boolean(
        window.Shopify && window.Shopify.designMode && this.dataset.showInEditor === 'true'
      );

      this.classList.remove(
        'is-preparing-second',
        'is-crossfading',
        'is-playing-second',
        'is-resetting-video',
        'is-overlay-visible',
        'is-replay-visible'
      );
      this.resetReplayControl();
      this.overlayContents.forEach((content) => {
        content.setAttribute('aria-hidden', 'true');
        content.setAttribute('inert', '');
      });

      this.videos.forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.preload = video === this.firstVideo || video === this.secondVideo ? 'auto' : 'metadata';
        video.addEventListener('loadedmetadata', () => {
          if (video === this.activeVideo) this.syncMobileFrameAspectRatio(video);
        }, { signal: this.abortController.signal });
        video.addEventListener('playing', () => this.handleVideoPlaying(video), {
          signal: this.abortController.signal
        });
        video.addEventListener('pause', () => this.handleVideoPaused(video), {
          signal: this.abortController.signal
        });
      });

      this.firstVideos.forEach((video) => {
        video.addEventListener('ended', () => {
          if (video === this.firstVideo && video === this.activeVideo) this.startSecondVideo();
        }, { signal: this.abortController.signal });
        video.addEventListener('error', () => {
          if (video === this.firstVideo && video === this.activeVideo) this.startSecondVideo();
        }, { signal: this.abortController.signal });
        video.addEventListener('transitionend', (event) => {
          if (
            video === this.firstVideo &&
            event.propertyName === 'opacity'
          ) this.finishSecondVideoTransition();
        }, { signal: this.abortController.signal });
      });

      this.secondVideos.forEach((video) => {
        video.addEventListener('waiting', () => {
          if (video !== this.secondVideo || this.activeVideo !== this.secondVideo) return;

          this.pauseOverlayCountdown();
          this.pauseReplayRevealCountdown();
        }, { signal: this.abortController.signal });

        video.addEventListener('error', () => {
          if (video !== this.secondVideo || this.activeVideo !== this.secondVideo) return;

          this.invalidatePlaybackRequests();
          this.classList.add('is-resetting-video');
          this.cancelVideoTransition({ restoreFirst: true });
          this.releaseVideoTransitionReset();
          this.activeVideo = null;
          this.autoplayBlocked = true;
          this.pauseOverlayCountdown();
          this.resetReplayControl();
          if (this.playFallback) this.playFallback.hidden = true;
          this.showOverlay();
        }, { signal: this.abortController.signal });
      });

      this.playFallback?.addEventListener('click', () => {
        this.userPaused = false;
        this.autoplayBlocked = false;
        this.playActiveVideo();
      }, {
        signal: this.abortController.signal
      });

      this.replayButton?.addEventListener('click', () => this.replayFromBeginning(), {
        signal: this.abortController.signal
      });
      this.reducedMotionQuery.addEventListener('change', (event) => {
        this.userPaused = event.matches;
        if (event.matches) {
          this.invalidatePlaybackRequests();
          this.cancelPendingResume();
          this.activeVideo?.pause();
          this.pauseOverlayCountdown();
          this.pauseReplayRevealCountdown();
          this.showOverlay();
          return;
        }
        this.resumeActiveVideoIfAllowed();
      }, { signal: this.abortController.signal });
      this.updateControlAvailability();

      window.addEventListener('resize', () => {
        const shouldUseMobileVideoSet = this.isMobileViewport();
        if (shouldUseMobileVideoSet !== this.isUsingMobileVideoSet) {
          this.isUsingMobileVideoSet = shouldUseMobileVideoSet;
          this.activateVideoSet();
          this.replayFromBeginning();
        }
        this.scheduleContentLayout();
      }, {
        signal: this.abortController.signal
      });

      if ('ResizeObserver' in window && this.frame) {
        this.contentResizeObserver = new ResizeObserver(() => this.scheduleContentLayout());
        this.contentResizeObserver.observe(this.frame);
      }

      document.fonts?.ready.then(() => {
        if (this.isConnected) this.scheduleContentLayout();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseOverlayCountdown();
          this.pauseReplayRevealCountdown();
          return;
        }

        this.resumeActiveVideoIfAllowed();
      }, { signal: this.abortController.signal });

      if (this.firstVideo) {
        this.firstVideo.hidden = false;
        this.activeVideo = this.firstVideo;
        this.firstVideo.loop = false;
        this.syncMobileFrameAspectRatio(this.firstVideo);
        if (this.userPaused) {
          this.showOverlay();
        } else {
          this.playActiveVideo();
        }
      } else {
        this.startSecondVideo();
      }

      this.scheduleContentLayout();
      if (this.shouldShowOverlayInEditor) this.showOverlay();
    }

    disconnectedCallback() {
      this.isDisconnecting = true;
      this.invalidatePlaybackRequests();
      this.abortController?.abort();
      this.clearOverlayTimer();
      this.clearReplayRevealTimer();
      this.cancelPendingResume();
      this.cancelContentLayout();
      this.contentResizeObserver?.disconnect();
      this.cancelVideoTransition();
      this.cancelVideoTransitionReset();
      this.videos?.forEach((video) => video.pause());
      this.activeVideo = null;
      this.isConnectedAndReady = false;
    }

    isMobileViewport() {
      return window.innerWidth < this.mobileBreakpoint;
    }

    getPreferredVideo(videos) {
      const desktopVideo = videos.find((video) => video.classList.contains('dvp__video--desktop'));
      const mobileVideo = videos.find((video) => video.classList.contains('dvp__video--mobile'));

      return this.isUsingMobileVideoSet
        ? mobileVideo || desktopVideo || null
        : desktopVideo || mobileVideo || null;
    }

    activateVideoSet() {
      this.firstVideo = this.getPreferredVideo(this.firstVideos);
      this.secondVideo = this.getPreferredVideo(this.secondVideos);
      this.videos.forEach((video) => {
        video.preload = video === this.firstVideo || video === this.secondVideo ? 'auto' : 'metadata';
      });
      this.syncMobileFrameAspectRatio(this.firstVideo || this.secondVideo);
      this.updateControlAvailability();
    }

    updateControlAvailability() {
      const hasActiveVideo = Boolean(this.firstVideo || this.secondVideo);
      if (this.replayButton) this.replayButton.disabled = !hasActiveVideo;
      if (this.videoControls) this.videoControls.hidden = !hasActiveVideo;
    }

    getVideoAspectRatio(video) {
      if (!video) return 0;

      if (video.videoWidth > 0 && video.videoHeight > 0) {
        return video.videoWidth / video.videoHeight;
      }

      const role = video.classList.contains('dvp__video--first') ? 'first' : 'second';
      const viewport = video.classList.contains('dvp__video--mobile') ? 'Mobile' : 'Desktop';
      const configuredRatio = Number.parseFloat(
        this.dataset[`${role}${viewport}VideoAspectRatio`]
      );

      return Number.isFinite(configuredRatio) && configuredRatio > 0 ? configuredRatio : 0;
    }

    syncMobileFrameAspectRatio(video = this.activeVideo || this.firstVideo || this.secondVideo) {
      if (!this.frame) return;

      if (!this.isMobileViewport()) {
        this.frame.style.removeProperty('--dvp-mobile-video-aspect-ratio');
        return;
      }

      const aspectRatio = this.getVideoAspectRatio(video);
      if (aspectRatio <= 0) return;

      this.frame.style.setProperty('--dvp-mobile-video-aspect-ratio', String(aspectRatio));
    }

    shouldUseDirectMobileSwitch() {
      if (!this.isMobileViewport() || !this.firstVideo || !this.secondVideo) return false;

      const firstRatio = this.getVideoAspectRatio(this.firstVideo);
      const secondRatio = this.getVideoAspectRatio(this.secondVideo);
      if (firstRatio <= 0 || secondRatio <= 0) return false;

      return Math.abs(firstRatio - secondRatio) / Math.max(firstRatio, secondRatio) > 0.001;
    }

    scheduleContentLayout() {
      this.cancelContentLayout();
      this.contentLayoutFrame = window.requestAnimationFrame(() => {
        this.contentLayoutFrame = null;
        this.layoutContentModules();
      });
    }

    cancelContentLayout() {
      if (this.contentLayoutFrame === null) return;

      window.cancelAnimationFrame(this.contentLayoutFrame);
      this.contentLayoutFrame = null;
    }

    layoutContentModules() {
      if (!this.contentLayer || this.contentPositioners.length === 0) return;

      const layerWidth = this.contentLayer.clientWidth;
      const layerHeight = this.contentLayer.clientHeight;
      if (layerWidth <= 0 || layerHeight <= 0) return;

      const isMobile = this.isMobileViewport();
      const prefix = isMobile ? 'mobile' : 'desktop';
      const orderedPositioners = [...this.contentPositioners].sort(
        (first, second) => Number(first.dataset.contentOrder) - Number(second.dataset.contentOrder)
      );
      const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));
      const measurements = orderedPositioners.map((positioner) => {
        const centered = positioner.dataset[`${prefix}Center`] === 'true';
        const horizontalSetting = Number.parseFloat(positioner.dataset[`${prefix}X`]);
        const verticalSetting = Number.parseFloat(positioner.dataset[`${prefix}Y`]);
        const horizontal = centered
          ? 50
          : clamp(Number.isFinite(horizontalSetting) ? horizontalSetting : 50, 0, 100);
        const vertical = clamp(Number.isFinite(verticalSetting) ? verticalSetting : 50, 0, 100);
        const width = Math.min(positioner.offsetWidth, layerWidth);
        const height = positioner.offsetHeight;

        positioner.classList.toggle('is-horizontally-centered', centered);

        return {
          positioner,
          width,
          height,
          desiredLeft: Math.max(0, layerWidth - width) * (horizontal / 100),
          desiredTop: Math.max(0, layerHeight - height) * (vertical / 100)
        };
      });

      let gap = isMobile ? 6 : 16;
      const contentHeight = measurements.reduce((total, item) => total + item.height, 0);
      if (contentHeight + gap * Math.max(0, measurements.length - 1) > layerHeight) gap = 0;

      const tops = [];
      measurements.forEach((item, index) => {
        const minimumTop = index === 0
          ? 0
          : tops[index - 1] + measurements[index - 1].height + gap;
        tops[index] = Math.max(item.desiredTop, minimumTop);
      });

      const finalIndex = measurements.length - 1;
      const overflow = tops[finalIndex] + measurements[finalIndex].height - layerHeight;
      if (overflow > 0) {
        tops[finalIndex] = layerHeight - measurements[finalIndex].height;
        for (let index = finalIndex - 1; index >= 0; index -= 1) {
          tops[index] = Math.min(
            tops[index],
            tops[index + 1] - measurements[index].height - gap
          );
        }
      }

      if (tops[0] < 0) {
        tops[0] = 0;
        for (let index = 1; index < tops.length; index += 1) {
          tops[index] = Math.max(
            tops[index],
            tops[index - 1] + measurements[index - 1].height + gap
          );
        }
      }

      measurements.forEach((item, index) => {
        item.positioner.style.left = `${Math.round(item.desiredLeft)}px`;
        item.positioner.style.top = `${Math.round(tops[index])}px`;
        item.positioner.style.transform = 'none';
      });
    }

    playActiveVideo() {
      const requestedVideo = this.activeVideo;

      if (!requestedVideo) {
        this.showOverlay();
        return;
      }

      if (this.isDisconnecting || this.userPaused) {
        return;
      }

      const playRequestId = ++this.playRequestId;
      this.autoplayBlocked = false;
      if (this.playFallback) this.playFallback.hidden = true;
      requestedVideo.muted = true;

      let playPromise;

      try {
        playPromise = requestedVideo.play();
      } catch (error) {
        this.handlePlaybackRejection(requestedVideo, playRequestId);
        return;
      }

      if (playPromise?.then) {
        playPromise
          .then(() => {
            if (
              playRequestId === this.playRequestId &&
              requestedVideo === this.activeVideo &&
              !requestedVideo.paused
            ) {
              this.handleVideoPlaying(requestedVideo);
            }
          })
          .catch(() => {
            this.handlePlaybackRejection(requestedVideo, playRequestId);
          });
      } else if (playRequestId === this.playRequestId && !requestedVideo.paused) {
        this.handleVideoPlaying(requestedVideo);
      }
    }

    handlePlaybackRejection(requestedVideo, playRequestId) {
      if (
        playRequestId !== this.playRequestId ||
        requestedVideo !== this.activeVideo ||
        this.isTransitioning ||
        this.isDisconnecting ||
        requestedVideo.error
      ) return;

      this.autoplayBlocked = true;
      if (requestedVideo === this.secondVideo) {
        this.pauseOverlayCountdown();
        this.pauseReplayRevealCountdown();
      }
      if (this.playFallback) this.playFallback.hidden = false;
    }

    handleVideoPlaying(video) {
      if (video !== this.activeVideo || this.isDisconnecting) {
        video.pause();
        return;
      }

      if (this.isTransitioning) {
        video.pause();
        return;
      }

      this.autoplayBlocked = false;
      if (this.playFallback) this.playFallback.hidden = true;

      if (this.classList.contains('is-resetting-video')) this.releaseVideoTransitionReset();

      if (video === this.secondVideo) {
        this.beginSecondVideoTransition();
        if (!this.hasShownOverlay) this.scheduleOverlay();
        this.scheduleReplayReveal();
      }
    }

    handleVideoPaused(video) {
      if (video !== this.activeVideo || this.isDisconnecting) return;

      if (video === this.secondVideo) {
        this.pauseOverlayCountdown();
        this.pauseReplayRevealCountdown();
      }

      if (
        this.isTransitioning ||
        this.userPaused ||
        this.autoplayBlocked ||
        video.ended ||
        document.hidden
      ) return;

      this.resumeActiveVideoIfAllowed();
    }

    resumeActiveVideoIfAllowed() {
      const video = this.activeVideo;

      if (
        !video ||
        this.isTransitioning ||
        this.isDisconnecting ||
        this.userPaused ||
        this.autoplayBlocked ||
        video.ended ||
        document.hidden ||
        !this.isConnected
      ) return;

      this.cancelPendingResume();
      this.resumeFrame = window.requestAnimationFrame(() => {
        this.resumeFrame = null;

        if (
          video === this.activeVideo &&
          video.paused &&
          !video.ended &&
          !this.isTransitioning &&
          !this.isDisconnecting &&
          !this.userPaused &&
          !this.autoplayBlocked &&
          !document.hidden &&
          this.isConnected
        ) {
          this.playActiveVideo();
        }
      });
    }

    cancelPendingResume() {
      if (this.resumeFrame === null) return;

      window.cancelAnimationFrame(this.resumeFrame);
      this.resumeFrame = null;
    }

    invalidatePlaybackRequests() {
      this.playRequestId += 1;
    }

    getVideoTransitionDuration() {
      return this.reducedMotionQuery?.matches ? 0 : this.videoTransitionDurationMilliseconds;
    }

    clearVideoTransitionTasks() {
      if (this.crossfadeFrame !== null) {
        window.cancelAnimationFrame(this.crossfadeFrame);
        this.crossfadeFrame = null;
      }

      window.clearTimeout(this.crossfadeTimer);
      this.crossfadeTimer = null;
    }

    cancelVideoTransition({ restoreFirst = false } = {}) {
      this.clearVideoTransitionTasks();
      this.isPreparingSecond = false;
      this.isCrossfading = false;
      this.classList.remove('is-preparing-second', 'is-crossfading');

      if (restoreFirst) {
        this.classList.remove('is-playing-second');
        if (this.firstVideo) this.firstVideo.hidden = false;
      }
    }

    cancelVideoTransitionReset() {
      if (this.resetTransitionFrame === null) return;

      window.cancelAnimationFrame(this.resetTransitionFrame);
      this.resetTransitionFrame = null;
    }

    releaseVideoTransitionReset() {
      this.cancelVideoTransitionReset();
      this.resetTransitionFrame = window.requestAnimationFrame(() => {
        this.resetTransitionFrame = null;
        this.classList.remove('is-resetting-video');
      });
    }

    beginSecondVideoTransition() {
      if (
        this.activeVideo !== this.secondVideo ||
        this.isCrossfading ||
        this.classList.contains('is-playing-second')
      ) return;

      const transitionDuration = this.getVideoTransitionDuration();

      if (!this.firstVideo || transitionDuration <= 0) {
        this.completeSecondVideoTransition();
        return;
      }

      this.isPreparingSecond = false;
      this.isCrossfading = true;
      this.clearVideoTransitionTasks();
      this.crossfadeFrame = window.requestAnimationFrame(() => {
        this.crossfadeFrame = window.requestAnimationFrame(() => {
          this.crossfadeFrame = null;

          if (
            !this.isCrossfading ||
            this.activeVideo !== this.secondVideo ||
            this.isDisconnecting
          ) return;

          this.classList.remove('is-preparing-second');
          this.classList.add('is-crossfading');
          this.crossfadeTimer = window.setTimeout(
            () => this.finishSecondVideoTransition(),
            transitionDuration + 200
          );
        });
      });
    }

    finishSecondVideoTransition() {
      if (!this.isCrossfading || this.activeVideo !== this.secondVideo) return;

      this.completeSecondVideoTransition();
    }

    completeSecondVideoTransition() {
      if (this.activeVideo !== this.secondVideo) return;

      this.clearVideoTransitionTasks();
      this.isPreparingSecond = false;
      this.isCrossfading = false;
      this.classList.remove('is-preparing-second', 'is-crossfading');
      this.classList.add('is-playing-second');
      if (this.firstVideo) this.firstVideo.hidden = true;
    }

    startSecondVideo() {
      if (this.hasSwitched) return;

      this.isTransitioning = true;
      this.invalidatePlaybackRequests();
      this.hasSwitched = true;
      this.autoplayBlocked = false;
      this.cancelPendingResume();
      this.cancelVideoTransition({ restoreFirst: true });
      this.resetReplayControl();
      const useDirectMobileSwitch = this.shouldUseDirectMobileSwitch();
      this.firstVideo?.pause();

      if (!this.secondVideo) {
        this.activeVideo = null;
        this.isTransitioning = false;
        this.showOverlay();
        return;
      }

      this.activeVideo = this.secondVideo;
      this.syncMobileFrameAspectRatio(this.secondVideo);
      this.secondVideo.muted = true;
      this.secondVideo.loop = true;
      this.resetVideo(this.secondVideo);
      this.overlayRemainingMilliseconds = this.overlayDelayMilliseconds;
      if (useDirectMobileSwitch) {
        this.classList.add('is-playing-second');
        if (this.firstVideo) this.firstVideo.hidden = true;
      } else {
        this.isPreparingSecond = true;
        this.classList.add('is-preparing-second');
      }
      this.isTransitioning = false;
      if (this.userPaused) {
        this.showOverlay();
      } else {
        this.playActiveVideo();
      }
    }

    replayFromBeginning() {
      this.isTransitioning = true;
      this.invalidatePlaybackRequests();
      this.userPaused = false;
      this.autoplayBlocked = false;
      this.cancelPendingResume();
      this.clearOverlayTimer();
      this.resetReplayControl();
      this.classList.add('is-resetting-video');
      this.cancelVideoTransition({ restoreFirst: true });
      this.videos.forEach((video) => video.pause());

      this.hasSwitched = false;
      this.hasShownOverlay = false;
      this.overlayRemainingMilliseconds = this.overlayDelayMilliseconds;
      this.classList.remove('is-playing-second', 'is-overlay-visible');
      this.overlayContents.forEach((content) => {
        content.setAttribute('aria-hidden', 'true');
        content.setAttribute('inert', '');
      });
      if (this.playFallback) this.playFallback.hidden = true;

      if (this.secondVideo) {
        this.secondVideo.hidden = false;
        this.secondVideo.loop = true;
        this.resetVideo(this.secondVideo);
      }

      if (this.firstVideo) {
        this.firstVideo.hidden = false;
        this.firstVideo.loop = false;
        this.resetVideo(this.firstVideo);
        this.activeVideo = this.firstVideo;
      } else if (this.secondVideo) {
        this.hasSwitched = true;
        this.classList.add('is-playing-second');
        this.activeVideo = this.secondVideo;
      } else {
        this.activeVideo = null;
      }

      this.syncMobileFrameAspectRatio(this.activeVideo);

      this.isTransitioning = false;
      if (this.shouldShowOverlayInEditor) this.showOverlay();

      if (this.activeVideo) {
        this.playActiveVideo();
      } else {
        this.releaseVideoTransitionReset();
        this.showOverlay();
      }
    }

    resetVideo(video) {
      try {
        video.currentTime = 0;
      } catch (error) {
        // The media timeline may not be ready yet; playback will still begin at its initial position.
      }
    }

    scheduleOverlay() {
      if (
        this.hasShownOverlay ||
        this.activeVideo !== this.secondVideo ||
        this.overlayTimer
      ) return;

      if (this.overlayRemainingMilliseconds <= 0) {
        this.showOverlay();
        return;
      }

      this.overlayCountdownStartedAt = performance.now();
      this.overlayTimer = window.setTimeout(() => {
        this.overlayTimer = null;
        this.overlayCountdownStartedAt = null;
        this.overlayRemainingMilliseconds = 0;
        this.showOverlay();
      }, this.overlayRemainingMilliseconds);
    }

    pauseOverlayCountdown() {
      if (this.overlayCountdownStartedAt !== null) {
        const elapsed = performance.now() - this.overlayCountdownStartedAt;
        this.overlayRemainingMilliseconds = Math.max(0, this.overlayRemainingMilliseconds - elapsed);
      }

      this.clearOverlayTimer();
    }

    clearOverlayTimer() {
      window.clearTimeout(this.overlayTimer);
      this.overlayTimer = null;
      this.overlayCountdownStartedAt = null;
    }

    scheduleReplayReveal() {
      if (
        !this.videoControls ||
        this.classList.contains('is-replay-visible') ||
        this.activeVideo !== this.secondVideo ||
        this.replayRevealTimer
      ) return;

      if (this.replayRevealRemainingMilliseconds <= 0) {
        this.showReplayControl();
        return;
      }

      this.replayRevealCountdownStartedAt = performance.now();
      this.replayRevealTimer = window.setTimeout(() => {
        this.replayRevealTimer = null;
        this.replayRevealCountdownStartedAt = null;
        this.replayRevealRemainingMilliseconds = 0;
        this.showReplayControl();
      }, this.replayRevealRemainingMilliseconds);
    }

    pauseReplayRevealCountdown() {
      if (this.replayRevealCountdownStartedAt !== null) {
        const elapsed = performance.now() - this.replayRevealCountdownStartedAt;
        this.replayRevealRemainingMilliseconds = Math.max(
          0,
          this.replayRevealRemainingMilliseconds - elapsed
        );
      }

      this.clearReplayRevealTimer();
    }

    clearReplayRevealTimer() {
      window.clearTimeout(this.replayRevealTimer);
      this.replayRevealTimer = null;
      this.replayRevealCountdownStartedAt = null;
    }

    resetReplayControl() {
      this.clearReplayRevealTimer();
      this.replayRevealRemainingMilliseconds = this.replayRevealDelayMilliseconds;
      this.classList.remove('is-replay-visible');
      if (this.videoControls) {
        this.videoControls.setAttribute('aria-hidden', 'true');
        this.videoControls.setAttribute('inert', '');
      }
    }

    showReplayControl() {
      if (!this.videoControls || this.activeVideo !== this.secondVideo || this.isDisconnecting) return;

      this.clearReplayRevealTimer();
      this.replayRevealRemainingMilliseconds = 0;
      this.classList.add('is-replay-visible');
      this.videoControls.removeAttribute('aria-hidden');
      this.videoControls.removeAttribute('inert');
    }

    showOverlay() {
      if (this.hasShownOverlay) return;

      this.clearOverlayTimer();
      this.overlayRemainingMilliseconds = 0;
      this.hasShownOverlay = true;
      this.classList.add('is-overlay-visible');
      this.overlayContents.forEach((content) => {
        content.removeAttribute('aria-hidden');
        content.removeAttribute('inert');
      });
    }
  }

  if (!customElements.get('dual-video-promo')) {
    customElements.define('dual-video-promo', DualVideoPromo);
  }

  } catch(e) { console.error(e); }
})();
})();
